<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between">
    <!-- Form -->
    <div class="text-center border border-light p-2 w-100">
      <div *ngIf="pageBusy" class="spinner-grow text-primary" size="sm" role="status">
        <span class="sr-only" role="status">Loading...</span>
      </div>
      <div *ngIf="!pageBusy">
        <div class="d-flex justify-content-between align-items-end mb-2">
          <div class="md-form col-sm-12 col-md-3 col-lg-2 mb-0">
            <input [(ngModel)]="searchText" mdbInput name="searchText" type="search" id="searchText" placeholder="Search" />
          </div>
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center mr-4">
              <label for="aitHistoryMonths" class="mb-0 mr-2 text-nowrap">AIT History Months</label>
              <input
                [(ngModel)]="aitHistoryMonths"
                name="aitHistoryMonths"
                type="number"
                id="aitHistoryMonths"
                min="1"
                class="form-control"
                style="width: 80px"
              />
            </div>
            <div class="form-check mr-3 mb-0">
              <input
                [(ngModel)]="includeExpiredPins"
                type="checkbox"
                id="includeExpiredPins"
                name="includeExpiredPins"
                class="form-check-input"
              />
              <label for="includeExpiredPins" class="form-check-label">Include Expired Pins</label>
            </div>
          </div>
        </div>
        <div class="table-responsive" style="overflow: visible">
          <table class="table" mdbTable hover="true" small="true" stickyHeader="true">
            <thead>
              <tr>
                <th>Id</th>
                <th scope="col" class="text-left sortable" [appSort]="userAitSearchResponse" data-order="desc" data-name="fullName">
                  Full Name
                </th>

                <th></th>
                <th scope="col" class="text-left sortable" [appSort]="userAitSearchResponse" data-name="balanceDate" data-type="date">
                  Balance Date
                </th>
                <th scope="col" class="text-left">Balance</th>
                <th scope="col" class="text-center">Update</th>
                <th scope="col" class="text-center">Documents</th>
              </tr>
            </thead>
            <tbody>
              <tr
                mdbTableCol
                *ngFor="let user of userAitSearchResponse | filter: searchText"
                [ngClass]="{
                  'update-success': user.recentlyUpdated,
                  'update-fail': user.error
                }"
              >
                <td>{{ user.userId }}</td>
                <td class="text-left">{{ user.fullName }}</td>
                <td class="text-left">
                  <span *ngIf="user.updateSuccess">
                    <mdb-icon fas icon="circle-check" class="action-icon"></mdb-icon>
                  </span>
                  <span *ngIf="user.error">
                    <mdb-icon fas icon="circle-xmark" class="action-icon sortable" (click)="popupError(user.error)"></mdb-icon>
                  </span>
                </td>
                <td class="text-left">
                  {{ user.balanceDate | date: "MMM dd, yyyy 'at:' hh:mm a" }}
                </td>
                <td class="text-left d-flex justify-content-start align-items-center" (click)="editField(user)">
                  <div class="md-form col-sm-12 col-md-6">
                    <input
                      [(ngModel)]="user.manuallyAddedBalance"
                      mdbInput
                      name="manualBalanceInput"
                      type="number"
                      id="manualBalance_{{ user.userId }}"
                      class="form-control"
                    />
                    <label for="manualBalance_{{ user.userId }}">
                      {{ user.balance | currency: "ZAR" : "symbol-narrow" }}
                    </label>
                  </div>
                  <span *ngIf="!user.isUpdating">
                    <button
                      mdbBtn
                      size="sm"
                      class="btn-trakly-action"
                      *ngIf="editMode && user === editedUserResponse"
                      (click)="saveRecord(user)"
                    >
                      Save
                    </button>
                  </span>
                </td>
                <td>
                  <span
                    size="sm"
                    mdbTooltip="Bank Balance Refresh"
                    class="fas fa-angle-right clickable action-icon"
                    (click)="GetUserBankBalance(user)"
                    *ngIf="!user.isUpdating; else busySpinner"
                  ></span>
                  <ng-template #busySpinner>
                    <div class="spinner-grow text-primary small-spinner" size="sm" role="status">
                      <span class="sr-only" role="status">Loading...</span>
                    </div>
                  </ng-template>
                </td>
                <td class="text-center">
                  <div class="btn-group" mdbDropdown>
                    <button type="button" mdbBtn class="dropdown-toggle waves-light btn-sm btn-trakly" mdbDropdownToggle mdbWavesEffect>
                      Generate
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" (click)="GenerateAITFullHistoryDoc(user)">
                        <span *ngIf="!user.isGeneratingAITHistoryDoc">Full Pin History</span>
                        <span
                          class="text-center"
                          *ngIf="user.isGeneratingAITHistoryDoc"
                          class="spinner-grow text-primary small-spinner"
                          size="sm"
                          role="status"
                        >
                        </span>
                      </a>
                      <a class="dropdown-item" (click)="GenerateLastApprovedPinDoc(user)">
                        <span *ngIf="!user.isGeneratingLastApprovedPinDoc">Last Approved Pin</span>
                        <span
                          class="text-center"
                          *ngIf="user.isGeneratingLastApprovedPinDoc"
                          class="spinner-grow text-primary small-spinner"
                          size="sm"
                          role="status"
                        >
                        </span>
                      </a>
                    </div>
                  </div>
                  <span
                    class="spinner-grow text-primary small-spinner"
                    size="sm"
                    role="status"
                    *ngIf="user.isGeneratingAITHistoryDoc || user.isGeneratingLastApprovedPinDoc"
                    style="margin-left: 15px"
                  >
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </mdb-card-body>

  <error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
</mdb-card>
